import React from 'react';
import { ITableDataSource } from 'models/table';
import { colors } from 'theme/colors';
import Grid from '@mui/material/Grid';
import { Typography } from '@mui/material';
import Button from 'components/atoms/Button';
import { EButtonVariants } from 'constants/Buttons';
import { formatDate } from 'utils/date';

interface ITranslationTableCard {
  data: ITableDataSource;
  editTranslations: (id: string) => void;
  dateFormat: string;
}

const TranslationTableCard = ({
  data,
  editTranslations,
  dateFormat,
}: ITranslationTableCard) => (
  <Grid
    container
    sx={{
      border: `1px solid ${colors.gray200}`,
      borderRadius: '4px',
      overflow: 'hidden',
      mt: 1,
      backgroundColor: colors.gray100,
    }}
  >
    <Grid
      size={{
        xs: 6,
        lg: 3,
      }}
      sx={{
        p: 2,
      }}
    >
      <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
        Language
      </Typography>
      <Typography variant="body2">{data.language}</Typography>
    </Grid>
    <Grid
      size={{
        xs: 6,
        lg: 3,
      }}
      sx={{
        p: 2,
      }}
    >
      <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
        Creation Date
      </Typography>
      <Typography variant="body2">{formatDate(data.createdDate, dateFormat)}</Typography>
    </Grid>
    <Grid
      size={{
        xs: 6,
        lg: 3,
      }}
      sx={{
        p: 2,
      }}
    >
      <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
        Last Update
      </Typography>
      <Typography variant="body2">{formatDate(data.lastModifiedDate, dateFormat)}</Typography>
    </Grid>
    <Grid
      container
      size={{ xs: 12 }}
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderTop: {
          xs: `1px solid ${colors.primary25}`,
          lg: 'none',
        },
        m: {
          xs: 2,
          lg: 2,
        },
        pt: 1,
      }}
    >
      <Grid size={{ xs: 12, sm: 'auto' }}>
        <Typography variant="button" sx={{ textTransform: 'uppercase' }}>
          Actions
        </Typography>
      </Grid>
      <Grid
        container
        sx={{ mt: 1, rowGap: 1, justifyContent: 'right' }}
        size={{ xs: 12, sm: 'auto' }}
      >
        <Grid size={{ xs: 12, sm: 'auto' }}>
          <Button
            label="Edit"
            variant={EButtonVariants.outlined}
            onClick={() => editTranslations(data.id as string)}
            size="small"
            fullWidth
            sx={{ minWidth: { sm: '120px' } }}
          />
        </Grid>
      </Grid>
    </Grid>
  </Grid>
);

export { TranslationTableCard };
